import {ModalBody, ModalFooter, Modal} from "reactstrap";
import React, { useEffect } from 'react';
import * as Yup from "yup";
import { useFormik } from "formik";
import { useTranslation } from 'react-i18next';
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import {viewEventSongs} from "../../slices/event/view/thunk";
import {voteSongGuest} from "../../slices/event/song/vote/thunk";
import {eventSongVoteReset} from "../../slices/event/song/vote/reducer";
import {validators} from "../../helpers/ValidatorHelper";


export const VoteModal = ({isModalRegisterAndVoteOpen, togModalRegisterAndVote, songId, eventId, requireTip, onPay}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const selectEventSongVote = createSelector(
    (state) => state.EventSongVote,
    (slice) => ({
      eventSongVoteSuccess: slice.success,
      eventSongVoteError: slice.violations,
    })
  );
  const {
    eventSongVoteError,
    eventSongVoteSuccess,
  } = useSelector(selectEventSongVote);

  useEffect(() => {
    if (eventSongVoteError?.length > 0 && isModalRegisterAndVoteOpen) {
      if (Array.isArray(eventSongVoteError)) {
        eventSongVoteError.forEach((violation) => {
          VoteForm.setFieldError(violation.propertyPath, t(violation.message));
        });
      } else {
        VoteForm.setStatus(t(eventSongVoteError))
      }
    }
    dispatch(eventSongVoteReset());
  }, [eventSongVoteError]);

  useEffect(() => {
    if (!isModalRegisterAndVoteOpen) {
      dispatch(eventSongVoteReset())
      VoteForm.resetForm();
    }
  }, [isModalRegisterAndVoteOpen]);

  useEffect(() => {
    if (eventSongVoteSuccess) {
      VoteForm.resetForm();
      if (isModalRegisterAndVoteOpen) {
        togModalRegisterAndVote();
      }
      dispatch(viewEventSongs(eventId))
    }
  }, [eventSongVoteSuccess]);



  const VoteForm = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: '',
      eventId: eventId,
      songId: songId,
    },
    validationSchema: Yup.object({
      username: validators.username(t),
      eventId: Yup.string().required(),
      songId: Yup.string().required()
    }),
    onSubmit: async (values) => {
      let payload = {};
      payload.user = {id: null, username: null};
      payload.user.username = values.username
      payload.song = {id: values.songId}
      payload.eventId = eventId;
      if (requireTip) {
        // Wymagany napiwek: najpierw płatność (imię gościa = nazwa z formularza), potem głos.
        onPay(payload, values.username);
      } else {
        dispatch(voteSongGuest(payload));
      }
    }
  });


  return (
    <Modal isOpen={isModalRegisterAndVoteOpen} toggle={togModalRegisterAndVote}>
      <form className="tablelist-form" onSubmit={(e) => {
        e.preventDefault();
        VoteForm.handleSubmit();
      }}>
        <ModalBody>
          {VoteForm.status &&
            <div className="alert alert-danger" role="alert">
              <strong>{t(VoteForm.status)}</strong>
            </div>
          }

        </ModalBody>
        <ModalFooter>
          <div className="hstack gap-2 justify-content-end">
            <button type="button" className="btn btn-label btn-light" onClick={togModalRegisterAndVote}>
              <i className="ri-close-circle-line label-icon align-middle fs-16 me-2"></i>{t('Close')}
            </button>
            <button type="submit" className="btn btn-label btn-success color-primary" id="add-btn">
              <i className="ri-check-double-line label-icon align-middle fs-16 me-2"></i>{t('Save')}
            </button>
          </div>
        </ModalFooter>
      </form>
    </Modal>
  );
}
